import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const data = [
    {
        title: "Shop hoa Tp.HCM",
        items: [
            {
                title: "Cn 1: ",
                link: "/1-hcm",
                description: "<p>377/18 Trần Bình Trọng, Quận 10</p>"
            },
            {
                title: "Cn 2: ",
                link: "/2-hcm",
                description: "<p>253 Lê Quang Định, Bình Thạnh</p>"
            },
            {
                title: "Cn 3: ",
                link: "/3-hcm",
                description: "<p>877 Âu Cơ, Tân Phú</p>"
            },
            {
                title: "",
                link: "",
                description: "<p>Giao hoa miễn phí nhanh chóng tới các Quận, Huyện trong Tp Hồ Chí Minh.</p>"
            },
        ]
    },
    {
        title: "Shop hoa Hà Nội",
        items: [
            {
                title: "Cn 1: ",
                description: "<p>165 Đường Cầu Giấy, Cầu Giấy</p>"
            },
            {
                title: "Cn 2: ",
                description: "<p>65 Đường Trần Phú, Ba Đình</p>"
            },
            {
                title: "",
                description: "<p>Miễn phí giao hoa tươi trên địa bàn Hà Nội: Cầu Giấy, Ba Đình, Đống Đa, Nam Từ Liêm, Hai Bà Trưng, Hoàn Kiếm, Thanh Xuân.</p>"
            }
        ]
    },
    {
        title: "",
        items: [
            {
                title: "Cn Bình Dương: ",
                description: "<p>231 Bùi Quốc Khánh, Chánh Nghĩa, Thủ Dầu Một</p>"
            },
            {
                title: "Cn Đồng Nai: ",
                description: "<p>263 Đồng Khởi, Tam Hiệp, Tp Biên Hòa</p>"
            },
            {
                title: "Cn Cần Thơ:",
                description: "<p>236 đường 30/4, phường Ninh Kiều, TP. Cần Thơ</p>"
            },
            {
                title: "Cn Đà Nẵng: ",
                description: "<p>144 Phạm Như Xương, Liên Chiểu</p>"
            },
            {
                title: "Cn Huế: ",
                description: "<p>231 Điện Biên Phủ, Trường An</p>"
            },
            {
                title: "Cn Bảo Lộc: ",
                description: "<p>710 Trần Phú, Lộc Tiến</p>"
            }
        ]
    },
    {
        title: "",
        items: [
            {
                title: "Cn Rạch Giá: ",
                description: "<p>31 Trần Văn Giàu, Nam An Hoà</p>"
            },
            {
                title: "Cn Nha Trang: ",
                description: "<p>85 Hương Lộ Ngọc Hiệp, Phương Sài</p>"
            },
            {
                title: "Cn Vũng Tàu: ",
                description: "<p>10a Đồng Khởi, Phường 1</p>"
            },
            {
                title: "Cn Bà Rịa: ",
                description: "<p>84 Nguyễn Thanh Đằng, Phước Trung</p>"
            },
            {
                title: "Cn Long An: ",
                description: "<p>213 Nguyễn Đình Chiểu</p>"
            },
            {
                title: "Cn Tây Ninh: ",
                description: "<p>1Cn Tây Ninh: 1057 Cách Mạng Tháng 8</p>"
            },
        ]
    }
];


const StoreList = () => {

    return (
        <div className="store-list-container mt-3">
            <div className="store-list-title mt-3">
                <div className="store-list-title-text">
                    <i className="bi bi-list me-2"></i>Danh Sách Cửa Hàng
                </div>
            </div>
            <div className="store-list-content">
                {data.map((item, idx) => (
                    <div className="store-list-content-item" key={idx}>
                        <div className="store-list-item-title mb-1">
                            {item.title}
                        </div>
                        {
                            item.items.map((ele, idx) => (
                                <div className="store-list-item-list" key={idx}>
                                    {ele.title != "" &&
                                        <Link >{ele.title}</Link>
                                    }
                                    <div className="store-description" dangerouslySetInnerHTML={{ __html: ele.description }}></div>
                                </div>
                            ))
                        }
                        {idx === data.length - 1 && (
                            <p>Xem thêm các chi nhánh <Link to={`/`}>Tại Đây</Link></p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default StoreList;
